export enum ModelNodeIdSuffixEnum {
  Filters = 'filters',
  Dimensions = 'dimensions',
  Measures = 'measures',
  Calculations = 'calculations'
}
